import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress
} from '@mui/material';
import DeleteOutlineTwoToneIcon from '@mui/icons-material/DeleteOutlineTwoTone';

interface DeleteConfirmDialogProps {
    open: boolean;
    title?: string;
    description: React.ReactNode;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    confirmText?: string;
    cancelText?: string;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
    open,
    title = 'Confirm Delete',
    description,
    loading = false,
    onCancel,
    onConfirm,
    confirmText = 'Delete',
    cancelText = 'Cancel',
}) => {
    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onCancel}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description"
        >
            <DialogTitle id="delete-dialog-title" sx={{fontSize:"22px", display:"flex", alignItems:"center", gap:.2}} bgcolor="error.main">
               <DeleteOutlineTwoToneIcon/> {title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="delete-dialog-description" py={2}>
                    {description}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button
                    onClick={onCancel}
                    disabled={loading}
                    variant="outlined"
                    sx={{color:"secondary.contrastText", borderColor:"secondary.contrastText"}}
                >
                    {cancelText}
                </Button>

                <Button
                    onClick={onConfirm}
                    disabled={loading}
                    variant="contained"
                    color="error"
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    {loading ? 'Deleting...' : confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;
